import React from "react";

function Gst() {
  return (
    <div
      style={{
        width: "80%",
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        flexDirection: "column",
        gap: 15,
        paddingRight: 10,
      }}
    >
      <div style={{ fontSize: 20, fontWeight: 600, textAlign: "left" }}>
        GST
      </div>
    </div>
  );
}

export default Gst;
